import { BooleanFlag, VariantFlag } from "./FeatureFlags";
import { getFlagIdentity } from "./flagIdentity";
import { evaluateFlag, evaluateVariant } from "./FliptFlagConfig";
import { FliptService, VariantEvaluation } from "./FliptService";

export class FeatureFlagsService {
  private static instance: FeatureFlagsService;
  private fliptService: FliptService | null = null;

  static getInstance(): FeatureFlagsService {
    if (!FeatureFlagsService.instance) {
      FeatureFlagsService.instance = new FeatureFlagsService();
    }
    return FeatureFlagsService.instance;
  }

  setFliptService(service: FliptService | null): void {
    this.fliptService = service;
  }

  getFliptService(): FliptService | null {
    return this.fliptService;
  }

  isFeatureEnabled(flag: BooleanFlag): boolean {
    return evaluateFlag(this.fliptService, flag, getFlagIdentity());
  }

  getVariant(flag: VariantFlag): VariantEvaluation {
    return evaluateVariant(this.fliptService, flag, getFlagIdentity());
  }
}
